import React from 'react'
import { Button, ControlLabel, Form, FormControl, FormGroup, Modal } from 'rsuite';
import { useAderenciaPrecosStore } from '../../AderenciaPrecos.store';
import styles from './ModalSavingFilters.module.scss';

type ModalSavingFiltersProps = {
    show?: boolean;
    nome?: string;
    onClose?: () => void;
    onClickSalvar?: () => void;
    onChange?: (value: string) => void;
}

export const ModalSavingFilters = ({ show, nome, onClose, onClickSalvar, onChange }: ModalSavingFiltersProps) => {
    return (
        <Modal
            className={styles["modal-salvar-filtro"]}
            backdrop="static"
            show={show}
            onHide={onClose}
        >
            <Modal.Header>
                <Modal.Title>Salvar filtro</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form fluid>
                    <FormGroup>
                        <ControlLabel>Nome do filtro</ControlLabel>
                        <FormControl
                            name="nome"
                            value={nome}
                            onChange={onChange}
                        />
                    </FormGroup>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <div
                    style={{
                        display: 'inline-block',
                        position: 'relative',
                        float: 'left',
                    }}
                >
                    <span
                        style={{ fontSize: '13px', color: '#8e8e93' }}
                    >
                        *A data escolhida não é salva no filtro
                    </span>
                </div>
                <Button
                    className={styles["btn-cancel"]}
                    appearance="default"
                    onClick={onClose}
                >
                    Descartar
                </Button>
                <Button
                    className={styles["btn-save"]}
                    appearance="primary"
                    onClick={onClickSalvar}
                >
                    Salvar filtro
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
